import { IList, IRecord } from 'annotation-tools/utils';
import { ProjectStatus } from '../../../types/enum/project-status';
import {
  APIRawValidationErrorType,
  APIValidationErrorType,
  IAPIValidationErrorType
} from '../common/validation-error';
import {
  ProjectAPIRawRequestBodyType,
  ProjectAPIRequestBodyType
} from './api-request-body';

export type ProjectAPIRawSuccessResponseType = {
  id: number;
  company_id: number;
  name: string;
  status: ProjectStatus;
  author: string;
  approver: string | undefined | null;
  can_be_deleted: boolean;
  created_at: string;
  updated_at: string;
};

export type ProjectAPIRawValidationErrorType = APIRawValidationErrorType<
  ProjectAPIRawRequestBodyType
>;

export type ProjectAPIValidationErrorType = APIValidationErrorType<
  ProjectAPIRequestBodyType
>;

export type IProjectAPIValidationErrorType = IAPIValidationErrorType<
  ProjectAPIRequestBodyType
>;

export const IProjectAPIValidationErrorFactory = IRecord<
  ProjectAPIValidationErrorType
>({
  name: IList<string>(),
  companyId: IList<string>()
});
